<template>
  <div id="app">
    <div class="all-main">
      <router-view />
    </div>

  </div>
</template>
<script>
export default {
  data: function () {
    return {
     
    };
  },
  watch:{
  
  },
  mounted() {
   
  },
};
</script>

<style lang="scss">
#app,
.app,
html,
body {
  width: 100%;
  height: 100vh;
  padding: 0px;
  margin: 0px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow: hidden;
}
.all-main{
  flex:1;
  height:calc(100vh - 38px);
  overflow: hidden;
}
#app {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow-y:auto;
}

#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.van-tabbar--fixed{
  position: inherit !important;
}

</style>
